import { useState } from 'react';
import { useLang } from 'hooks/lang';

import { getSampleProjectUrl, loaders } from 'entities';

import { Table, IconButton, Card, Button, ComponentOrNode } from 'components/Blocks';
import { EntityStatusTag } from 'components/Entities';
import { UserAvatar } from 'components/UserAvatar';
import { ExpandIcon } from 'components/Icons';

import { RecruitmentModal } from 'pages/Recruitment/components';

import { useTaskModal } from '../context.taskModal';

import { listUpdate } from 'utils/array';
import { getCountryLabel } from 'utils/countries';
import { useModalsTaskOption } from '../taskModalOption.hook';

export function TaskRecruitment() {
  const { t } = useLang();
  const { task } = useTaskModal();

  const [recruitmentId, setRecruitmentId] = useState<string | null>(null);

  const requestRecruitment = useModalsTaskOption('REQUEST_RECRUITMENT');

  const recruitments = loaders.projects.listProjectRecruitments.use({
    defaultValue: [],

    params: {
      projectId: task.projectId,
    },

    reloadOnChangeRef: task.activeRecruitments,

    parser: (recruitments) => recruitments.filter((r) => r.task == task.id),
  });

  return (
    <>
      {recruitmentId && (
        <RecruitmentModal
          recruitmentId={recruitmentId}
          close={() => setRecruitmentId(null)}
          onData={(recruitment) =>
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            recruitments.overwrite((old) => listUpdate(old, recruitment as any))
          }
        />
      )}

      <Card>
        <Table
          items={recruitments.data}
          loading={recruitments.loading}
          uniqueKey="id"
          columns={[
            {
              label: 'Sample ID',
              property: 'sampleId',
              render: ({ sampleId }) => (
                <Button
                  size="fit"
                  variant="link"
                  className="text-sm font-normal text-inherit"
                  href={getSampleProjectUrl(sampleId, 'stats')}
                  linkTarget={sampleId}
                >
                  {sampleId}
                </Button>
              ),
            },

            {
              label: t('country')!,
              property: 'country',
              render: ({ country }) => getCountryLabel(country),
            },

            {
              label: t('owner')!,
              render: ({ owner }) => <UserAvatar user={owner} name />,
            },

            {
              label: t('status') as string,
              className: 'text-center',
              render: ({ status }) => <EntityStatusTag target="recruitments" status={status} />,
            },

            {
              render: (recruitment) => (
                <IconButton
                  className="ml-auto flex"
                  onClick={() => setRecruitmentId(recruitment.id)}
                >
                  <ExpandIcon />
                </IconButton>
              ),
            },
          ]}
        />
      </Card>

      {requestRecruitment.isEnabled && (
        <Button onClick={requestRecruitment.action} variant="ghost">
          <ComponentOrNode target={requestRecruitment.Icon} />
          {requestRecruitment.getLabel?.(t)}
        </Button>
      )}
    </>
  );
}
